import React, { useRef, useState } from "react";
// import "./TemplatComman.css";

import "./Theme63.css";
import styled from "styled-components";
import banner from "./../../../../Images/theme-63-banner.png";
import logo from "./../../../../Images/theme63Logo.png";
import CabIcon from "./../../../../Images/Defaultcabtab.png";

import AvilableCab from "./../../../../Images/Defaultavilablecabtab.png";
import AboutIcon from "./../../../../Images/Defaultabouttab.png";
import TermCondIcon from "./../../../../Images/Defaultterm&contab.png";
import COntactIcon from "./../../../../Images/DefaultContacttab.png";
// import AvilableCabTab from "./AvilableCabTab";
// import AvilableCabTab1 from "./AvilableCabTab1";
import { LogisticHome } from "./LogisticHome";
import LogisticAbout from "./LogisticAbout";
import SubService from "./SubService";
import LogisticContactInfo from "./LogisticContactInfo";
import TermAndCondition from "./TermAndCondition";



const Theme63Template = (props) => {
  const [activeTab, setActiveTab] = useState("home");

  const renderContent = () => {
    switch (activeTab) {
      case "home":
        return <LogisticHome />;
      case "about":
        return <LogisticAbout />;
      case "services":
        return <SubService />;
      case "contact":
        return <LogisticContactInfo />;
      case "termcondition":
        return <TermAndCondition />;
      default:
        return null;
    }
  };



  return (
    <div>
      <div class="main-temaplt" id="temp63">
        <div className="container">
          <div className="row justify-content-center">
            <div style={{ width: "420px" }} className="col-12 wtemplate">
              <div>
                <div className="relative bannerImg">
                  <img loading="lazy" className="w-full" src={banner} />
                  <div className="flex  absolute items-center text-center" style={{ top: "50px", flexDirection: "column", lineHeight: "10px" }}>
                    <img loading="lazy" className=" pb-2" style={{ maxHeight: "50px", height: '100%' }} src={logo} />
                    <div className="font-DM   uppercase break-all">Fast and effective service with a smile.</div>
                  </div>
                </div>

                <div className="d-flex overflow-scroll menuIcons">
                  <div className={`icon ${activeTab === 'home' ? 'active' : ''}`} onClick={() => setActiveTab('home')}>
                    <i className="fa-solid fa-house"></i>
                    <div className="">Home</div>
                  </div>

                  <div className={`icon ${activeTab === 'about' ? 'active' : ''}`} onClick={() => setActiveTab('about')}>
                    <i className="fa-solid fa-circle-info"></i>
                    <div className="">About</div>
                  </div>

                  <div className={`icon ${activeTab === 'services' ? 'active' : ''}`} onClick={() => setActiveTab('services')}>
                    <i className="fa-solid fa-gear"></i>
                    <div className="">Services</div>
                  </div>

                  <div className={`icon ${activeTab === 'contact' ? 'active' : ''}`} onClick={() => setActiveTab('contact')}>
                    <i className="fa-solid fa-id-badge"></i>
                    <div className="">Contact</div>
                  </div>

                  <div className={`icon ${activeTab === 'termcondition' ? 'active' : ''}`} onClick={() => setActiveTab('termcondition')}>
                    <i className="fa-solid fa-file-invoice"></i>
                    <div className="">T&C</div>
                  </div>
                </div>

                <div className="" style={{ height: "calc(100vh - 262px)" }}>{renderContent()}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Theme63Template;
